// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"9fa253ee","460":"ce74cf7c","556":"3deaf17e","710":"70293755","775":"d43eb134","778":"ef8e1761","826":"d4ed0f7e"}[chunkId] + ".chunk.js";
};